import { render, staticRenderFns } from "./DiagramRvs.vue?vue&type=template&id=8afb27ce&scoped=true"
import script from "./DiagramRvs.vue?vue&type=script&lang=ts"
export * from "./DiagramRvs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afb27ce",
  null
  
)

export default component.exports